import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-left">
          <img src="/assets/nexus-concordat-logo.png" alt="Nexus Concordat" className="footer-logo" />
          <span>&copy; 2025-2026 Nexus Concordat. All rights reserved. Patent Pending.</span>
        </div>
        <div className="footer-links">
          <a href="#technology">Technology</a>
          <a href="#portfolio">Portfolio</a>
          <a href="#contact">Contact</a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
